import React from 'react';

interface SortIconProps {
  isActive: boolean;
  direction: 'asc' | 'desc';
  onClick?: () => void;
}

const SortIcon: React.FC<SortIconProps> = ({ isActive, direction, onClick }) => {
  const upColor = isActive && direction === 'asc' ? '#0074cb' : '#374957';
  const downColor = isActive && direction === 'desc' ? '#0074cb' : '#262626';

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <span 
      className="sort-icon" 
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      role="button" 
      tabIndex={0}
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        marginLeft: '4px',
        verticalAlign: 'middle'
      }}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        height="8" 
        fill="none" 
        viewBox="0 0 11 6" 
        width="12"
        style={{ marginBottom: '-2px' }}
      >
        <path 
          d="M9.51548 5.83799C9.42154 5.83854 9.32842 5.82057 9.24145 5.78512C9.15449 5.74968 9.07539 5.69745 9.00869 5.63144L5.73957 2.36213C5.67322 2.29537 5.59427 2.24238 5.50729 2.20622C5.42031 2.17006 5.32702 2.15144 5.23279 2.15144C5.13856 2.15144 5.04527 2.17006 4.95829 2.20622C4.8713 2.24238 4.79236 2.29537 4.726 2.36213L1.45689 5.63144C1.32248 5.76556 1.14018 5.84091 0.950101 5.84091C0.760019 5.84091 0.577723 5.76556 0.443316 5.63144C0.308908 5.49731 0.233398 5.3154 0.233398 5.12573C0.233398 5.03181 0.251937 4.93881 0.287954 4.85204C0.323972 4.76527 0.376764 4.68643 0.443316 4.62002L3.71957 1.35783C4.12639 0.967816 4.66865 0.75 5.23279 0.75C5.79693 0.75 6.33919 0.967816 6.74601 1.35783L10.0223 4.62002C10.0892 4.68623 10.1423 4.76501 10.1785 4.8518C10.2147 4.9386 10.2334 5.0317 10.2334 5.12573C10.2334 5.21975 10.2147 5.31285 10.1785 5.39965C10.1423 5.48644 10.0892 5.56522 10.0223 5.63144C9.95557 5.69745 9.87647 5.74968 9.7895 5.78512C9.70254 5.82057 9.60942 5.83854 9.51548 5.83799Z" 
          fill={upColor}
        />
      </svg>
      <svg 
        viewBox="0 0 11 6" 
        xmlns="http://www.w3.org/2000/svg" 
        height="8" 
        fill="none" 
        width="12"
        style={{ marginTop: '5px' }}
      >
        <path 
          d="M10.0257 0.553683C9.95932 0.487162 9.88033 0.434363 9.79329 0.398332C9.70626 0.362301 9.61291 0.34375 9.51863 0.34375C9.42434 0.34375 9.33099 0.362301 9.24396 0.398332C9.15693 0.434363 9.07794 0.487162 9.01154 0.553683L5.74048 3.80418C5.67409 3.8707 5.5951 3.9235 5.50806 3.95953C5.42103 3.99557 5.32768 4.01412 5.2334 4.01412C5.13911 4.01412 5.04576 3.99557 4.95873 3.95953C4.8717 3.9235 4.79271 3.8707 4.72631 3.80418L1.45525 0.553683C1.38886 0.487162 1.30987 0.434363 1.22284 0.398332C1.1358 0.362301 1.04245 0.34375 0.948169 0.34375C0.853886 0.34375 0.760535 0.362301 0.673503 0.398332C0.58647 0.434363 0.507478 0.487162 0.441084 0.553683C0.308062 0.686657 0.233398 0.866536 0.233398 1.05403C0.233398 1.24153 0.308062 1.42141 0.441084 1.55438L3.71928 4.81198C4.12103 5.2107 4.6656 5.43466 5.2334 5.43466C5.80119 5.43466 6.34577 5.2107 6.74751 4.81198L10.0257 1.55438C10.1587 1.42141 10.2334 1.24153 10.2334 1.05403C10.2334 0.866536 10.1587 0.686657 10.0257 0.553683Z" 
          fill={downColor}
        />
      </svg>
    </span>
  );
};

export default SortIcon;
